import React from 'react';

// Images
import CrateBarrelCard from 'assets/images/website/registryOnboard/CrateBarrelCard';
import OxoCard from 'assets/images/website/registryOnboard/OxoCard';
import KitchenAidCard from 'assets/images/website/registryOnboard/KitchenAidCard';
import KateSpadeCard from 'assets/images/website/registryOnboard/KateSpadeCard';
import DeltaLogo from 'assets/images/website/registryOnboard/logos/Delta';
import AirbnbLogo from 'assets/images/website/registryOnboard/logos/Airbnb';
import BlueApronLogo from 'assets/images/website/registryOnboard/logos/BlueApron';
import UberLogo from 'assets/images/website/registryOnboard/logos/Uber';
import HomeDepotLogo from 'assets/images/website/registryOnboard/logos/HomeDepot';
import CoupleBeachWalk from 'assets/images/website/registryOnboard/honeymoon/CoupleBeachWalk';
import CoupleGardening from 'assets/images/website/registryOnboard/honeymoon/CoupleGardening';
import PaintedLady from 'assets/images/website/registryOnboard/honeymoon/PaintedLady';
import Avocados from 'assets/images/website/registryOnboard/honeymoon/Avocados';

import SectionContainer from '../SectionContainer/SectionContainer';
import AddExternalSection from '../AddExternalSection/AddExternalSection';
import BuildZolaRegistryCTA from '../../../components/BuildZolaRegistryCTA';

import styles from './UniversalRegistrySection.module.less';

const UniversalRegistryColumn = ({ hed, className, children }) => {
  return (
    <div className={`${className} ${styles.column}`}>
      <h4>{hed}</h4>
      {children}
      <BuildZolaRegistryCTA className={styles.btnSpacing} />
    </div>
  );
};

const UniversalRegistrySection = () => {
  return (
    <SectionContainer className={styles.sectionColor}>
      <div className={styles.universalRegistryContainer}>
        <h3>Our Store Carries It All</h3>
        <div className={styles.columns}>
          <UniversalRegistryColumn hed="Over 800 Top Brands">
            <div>
              <img className={styles.brandCard} src={KitchenAidCard} alt="kitchen-aid-card" />
              <img className={styles.brandCard} src={OxoCard} alt="oxo-card" />
              <img className={styles.brandCard} src={CrateBarrelCard} alt="crate-barrel-card" />
              <img className={styles.brandCard} src={KateSpadeCard} alt="kate-spade-card" />
            </div>
          </UniversalRegistryColumn>
          <UniversalRegistryColumn className={styles.columnSpacing} hed="Cool Experiences">
            <div className={styles.logoContainer}>
              <img className={styles.logo} src={DeltaLogo} alt="kitchen-aid-card" />
              <img className={styles.logo} src={AirbnbLogo} alt="kitchen-aid-card" />
              <img className={styles.logo} src={BlueApronLogo} alt="kitchen-aid-card" />
              <img className={styles.logo} src={UberLogo} alt="kitchen-aid-card" />
              <img className={styles.logo} src={HomeDepotLogo} alt="kitchen-aid-card" />
            </div>
          </UniversalRegistryColumn>
          <UniversalRegistryColumn className={styles.columnSpacing} hed="Honeymoon and Cash Funds">
            <div className={styles.honeymoonCards}>
              <div className={styles.honeymoonCard}>
                <img
                  className={styles.honeymoonImg}
                  src={CoupleBeachWalk}
                  alt="couple-beach-walk"
                />
                <p className={styles.dek}>Round Trip Honeymoon Airfare</p>
              </div>
              <div className={`${styles.honeymoonCard} ${styles.honeymoonCardSpacing}`}>
                <img className={styles.honeymoonImg} src={PaintedLady} alt="painted-lady" />
                <p className={styles.dek}>Home Down Payment</p>
              </div>
              <div className={`${styles.honeymoonCard} ${styles.honeymoonCardSpacing}`}>
                <img className={styles.honeymoonImg} src={CoupleGardening} alt="couple-gardening" />
                <p className={styles.dek}>Our Favorite Charity</p>
              </div>
              <div className={`${styles.honeymoonCard} ${styles.honeymoonCardSpacing}`}>
                <img className={styles.honeymoonImg} src={Avocados} alt="avocados" />
                <div>
                  <p className={styles.dek}>Create a Custom Fund</p>
                  <p>Eg. Lifetime Supply of Avocados</p>
                </div>
              </div>
            </div>
          </UniversalRegistryColumn>
        </div>
      </div>
      <AddExternalSection />
    </SectionContainer>
  );
};

export default UniversalRegistrySection;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/components/UniversalRegistrySection/UniversalRegistrySection.jsx